export default __webpack_public_path__ + "69cf03d85015b0a2c14d4868ad80a158.png";